exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Iframe1 .placeholder{width:100%;height:100%;color:#999;background-color:#f9f9f9}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/sass-loader/lib/loader.js!./src/components/contents/Iframe1/Iframe1.scss
// module id = 991
// module chunks = 27